import { Link } from 'react-router-dom';

import Button, { type ButtonProps } from '@/components/atoms/Button';

import IconLinkOrange from '@/assets/icons/LinkOrangeIcon.svg?react';
import { ExternalLinkIcon } from 'lucide-react';

export type LinkButtonProps = {
  children: React.ReactNode;
  to: string;
  target?: React.HTMLAttributeAnchorTarget;
} & ButtonProps;

const LinkButton = ({ children, target = '_blank', to, ...props }: LinkButtonProps) => {
  return (
    <button
      className="flex items-center rounded-[8px] border border-gr-200 bg-gr-100 px-2.5 py-1.5 hover:bg-gr-200 active:bg-gr-100"
      {...props}
    >
      <Link to={to} target={target} className="flex items-center space-x-[8px]">
        <div className=" text-gr-700 Body5M14">{children}</div>
        <span>
          <ExternalLinkIcon width={16} height={16} className="text-gr-700" />
        </span>
      </Link>
    </button>
  );
};

export default LinkButton;
